import { Coordinate } from '@shared//models/coordinate.model'
import { BaseModel } from '@shared/models/base.model'
import { Team } from '@shared/models/team.model'

export class Geofence extends BaseModel {
  id: number
  name: string
  polygon: string
  coordinates: Coordinate[]
  status: GeofenceStatus
  createdAt: string
  groups: GeofenceGroup[]
  updatedAt: string
  teamId?: number
  team: Team
  readOnly: boolean
}

export type GeofenceTruncated = Pick<Geofence, 'id' | 'name' | 'coordinates' | 'groups' | 'readOnly'>

export type GeofenceInput = Pick<Geofence, 'name' | 'coordinates' | 'teamId'>

export enum GeofenceStatus {
  Active = 'active',
  Archived = 'archive',
  Deleted = 'deleted',
}

export class GeofenceGroup {
  id: number
  name: string
  status: GeofenceStatus
  color: string
  createdAt: string
  updatedAt: string
  teamId?: number
  areas: Geofence[]
  team: Team
  readOnly: boolean
}

export interface GeofencesGroupInput {
  name: string
  teamId: number
  areaIds: number[]
}
